// @flow
import React from "react";
import RichTextEditor from "react-rte";

// import styles from "./richTextInput.scss";

type Props = {
  onChange: Function,
  defaultValue?: any,
  resetText?: boolean
};

type State = {
  value: String
};

class RichTextInput extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.defaultValue
        ? RichTextEditor.createValueFromString(this.props.defaultValue, "html")
        : RichTextEditor.createEmptyValue()
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.defaultValue !== this.props.defaultValue) {
      this.setState({
        value: RichTextEditor.createValueFromString(
          nextProps.defaultValue,
          "html"
        )
      });
    }

    // To reset the text
    if (nextProps.resetText !== this.props.resetText) {
      this.setState({
        value: RichTextEditor.createValueFromString("", "html")
      });
    }
  }

  onChange(val) {
    this.setState({ value: val }, () => {
      this.props.onChange(val.toString("html"));
    });
  }

  render() {
    return (
      <RichTextEditor
        value={this.state.value}
        onChange={value => this.onChange(value)}
      />
    );
  }
}

RichTextInput.defaultProps = {
  defaultValue: null,
  resetText: null
};

export default RichTextInput;



// WEBPACK FOOTER //
// ./app/components/commons/formElements/richTextInput/richTextInput.js